module.exports = __webpack_public_path__ + "img/secure-payment.0050859c.svg";